<template>
  <div class="d-flex justify-space-between" style="position: relative">
    <template v-if="true">
      <router-view />
    </template>
    <v-overlay :value="!allowedSite()">
      <SelectSiteContainer />
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectSiteContainer from '/src/container/shared/MasterAdminHeader/SelectSiteContainer'

export default {
  components: { SelectSiteContainer },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.siteKey = params.siteKey
      }
    )
  },
  mounted () {
    if (this.allowedSite() || !this.$route.params.siteKey) return

    const payload = {
      status: 400,
      message: '権限を持っていないサイトか、存在しないサイトです。'
    }
    this.$store.dispatch('SystemMessageStore/createMessage', payload)
  },
  methods: {
    allowedSite () {
      return !!this.currentUserAuth.sites.find(
        (site) => site.siteKey === this.$route.params.siteKey
      )
    }
  }
}
</script>
